export const business_category = {
  FETCH_BUSINESS_CATEGORIES_LOADING: 'FETCH_BUSINESS_CATEGORIES_LOADING',
  FETCH_BUSINESS_CATEGORIES_SUCCESS: 'FETCH_BUSINESS_CATEGORIES_SUCCESS'
};
